/* eslint-disable max-len */
/**
 * Conteúdo do Termo de Ciência da linha BADESUL MPE (GYR-1711).
 *
 * ⚠️ RASCUNHO — a redação final depende de revisão de produto/jurídico (CA-6 do card).
 * ⚠️ `BADESUL_MPE_FOUNDATION_MONTHS` é o único número ainda NÃO confirmado pelo Badesul.
 *    Não existe validação de tempo mínimo de fundação em nenhum ponto do código legado;
 *    o valor veio do rascunho do card. Trocar aqui atualiza destaques e texto integral.
 *
 * Espelho deste arquivo no dashboard: `dashboard/src/utils/badesul-terms.js`.
 * (app e dashboard são repos separados, sem pacote compartilhado — mesma duplicação
 * intencional já adotada para os termos do BADESC e para as regras de estado civil.)
 */

const BADESUL_MPE_FOUNDATION_MONTHS = 24;

const badesulMpeHighlights = [
  {
    title: 'Quem pode contratar',
    items: [
      'Empresa com sede no estado do Rio Grande do Sul.',
      'Faturamento anual de até R$ 20 milhões.',
      `Tempo mínimo de fundação de ${BADESUL_MPE_FOUNDATION_MONTHS} meses.`,
    ],
  },
  {
    title: 'Custos da operação',
    items: [
      'Taxa de adesão (análise) de 0,8% do valor contratado, paga antes da assinatura da CCB (Cédula de Crédito Bancário).',
      'Incidência de IOF.',
      'Desconto da taxa de contratação do fundo garantidor FGI PEAC.',
    ],
  },
];

// O título fica a cargo de quem renderiza (o modal já o exibe no header).
const termsOfUseBadesulMPE = `Quem pode contratar

- Empresa com sede no estado do Rio Grande do Sul.
- Faturamento anual de até R$ 20 milhões.
- Tempo mínimo de fundação de ${BADESUL_MPE_FOUNDATION_MONTHS} meses.

Custos da operação

- Taxa de adesão (análise) de 0,8% do valor contratado, paga antes da assinatura da CCB (Cédula de Crédito Bancário).
- Incidência de IOF.
- Desconto da taxa de contratação do fundo garantidor FGI PEAC.

Condições de pagamento

- Prazo total de até 60 meses.
- Carência de até 6 meses (até 2 parcelas trimestrais, apenas de juros).
- Após a carência, amortização mensal (mínimo de 12 parcelas).
- Vencimento todo dia 15.

O que você está declarando

- As informações prestadas são verdadeiras.
- A proposta está sujeita a análise de crédito e ao enquadramento nas regras do BADESUL/BNDES; a simulação apresentada não é garantia de aprovação.
- A taxa final pode variar conforme o indexador escolhido (TLP, Fixa ou LCD) até o momento da contratação.`;

/**
 * Mapas por `portfolioName`, no mesmo padrão do `AllTermsOfUseBadesc`.
 * As demais carteiras Badesul (Microcrédito, Reconstrução RS, Enquadramento) ainda não
 * têm termo escrito e por isso ficam de fora — quem não estiver aqui mantém o
 * comportamento antigo (link externo).
 */
const AllTermsOfUseBadesul = {
  'Badesul MPE': termsOfUseBadesulMPE,
};

// Só o dashboard renderiza os destaques (o parceiro precisa ler as regras para o cliente).
// No app eles saíram do modal a pedido do produto — lá basta o checkbox, com o termo
// integral a um clique. O mapa fica aqui para o arquivo seguir espelho do dashboard: a
// revisão de texto do CA-6 é a mesma nos dois repos.
const AllBadesulHighlights = {
  'Badesul MPE': badesulMpeHighlights,
};

// Só os mapas são exportados: `utils/index.js` faz `export *`, então exportar as peças
// intermediárias vazaria nomes mortos para o barrel compartilhado.
export {
  AllTermsOfUseBadesul,
  AllBadesulHighlights,
};
